import { FloaterIndex } from "../../types/amr-pipeline/enums/FloaterIndex";

export const coupon = [FloaterIndex.Fixed, FloaterIndex.Sofr, FloaterIndex.Sonia, FloaterIndex.Libor, FloaterIndex.Euribor];